import { render, staticRenderFns } from "./createEventBot.vue?vue&type=template&id=31e27ac2"
import script from "./createEventBot.vue?vue&type=script&lang=js"
export * from "./createEventBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports